import React, { useState } from 'react';
import hoistStatics from 'hoist-non-react-statics';

import { useTranslationService } from 'src/services/TranslationService';

// Api
import { usersBasicInfo, userMe } from 'src/api/authentication';


const ProfileService = React.createContext({
    profile: {},
    getProfileData: () => {
    },
    setProfileData: (profile) => {
    },
});

ProfileService.Consumer.displayName = 'ProfileService';

export const useProfileService = () => {
    const context = React.useContext(ProfileService);
    if (context === undefined) {
        throw new Error('useProfileService must be used within a ProfileProvider');
    }
    return context;
};

export const ProfileProvider = ({ children }) => {
    const [profile, setProfile] = useState(null);
    const { setLanguage } = useTranslationService();

    const getProfileData = () => {
        userMe().then((responseMe) => {
            usersBasicInfo().then((response) => {
                setProfile({...responseMe, ...response});
                setLanguage(response.locale)
            }).catch(() => {
                setProfile(responseMe);
            });
        });
    };

    const setProfileData = (profile) => {
        setProfile(profile);
    };

    const context = {
        profile,
        getProfileData,
        setProfileData
    };

    return (<ProfileService.Provider value={context}>
        {children}
    </ProfileService.Provider>);
};

ProfileProvider.displayName = 'ProfileProvider';

export const withProfile = (Component) => {
    const displayName = 'withProfile(' + (Component.displayName || Component.name) + ')';

    const Wrapper = ({ wrappedComponentRef, ...rest }) =>
        React.createElement(ProfileService.Consumer, null, context => {
            const {
                profile,
                getProfileData,
                setProfileData
            } = context;
            return (
                React.createElement(Component, Object.assign({}, rest, {
                        profile,
                        getProfileData,
                        setProfileData
                }, {
                    ref: wrappedComponentRef
                })
                ));
        });

    Wrapper.displayName = displayName;
    Wrapper.WrappedComponent = Component;

    return hoistStatics(Wrapper, Component);
};
